//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import {
    ver,
    system
} from '../../api';
import MHeader from '../Header/Header.vue';
export default {
    data() {
        return {
            token: "",
            imgUrl: "",
            wxReady: "No",
            selectReponse: "not select",
            uploadReponse: "not call"
        }
    },
    components: {
        MHeader
    },
    created() {
        this.token = this.$route.query.token
        var that = this
        wx.ready(function (res) {
            that.wxReady = "Ready"
        })
    },
    methods: {
        selectPic() {
            var that = this
            that.selectReponse = "selecting"
            wx.chooseImage({
            	success: function(res) {
                    that.selectReponse = "selected " + res.localIds.length + " files"
                    that.uploadReponse = "uploading"
            		wx.uploadImage({
                        localId: res.localIds[0],
                        isShowProgressTips: 1,
                        success: function (res) {
                            that.uploadReponse = "mediaId:" + res.serverId
                            that.imgUrl = 'https://api.weixin.qq.com/cgi-bin/media/get?access_token='+that.token+'&media_id='+res.serverId
                        }
                    });
            	},
                fail: function(res) {
                    that.selectReponse = "fail: " + res.errMsg
                }
            })
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Wechat/Test.vue